export default "__VITE_ASSET__c959fc8e__"